import { render, staticRenderFns } from "./TeamsportTeamLogo.vue?vue&type=template&id=1e2f7210&scoped=true"
import script from "./TeamsportTeamLogo.vue?vue&type=script&lang=js"
export * from "./TeamsportTeamLogo.vue?vue&type=script&lang=js"
import style0 from "./TeamsportTeamLogo.vue?vue&type=style&index=0&id=1e2f7210&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2f7210",
  null
  
)

export default component.exports